import { render, staticRenderFns } from "./Step8.vue?vue&type=template&id=2c44da18&scoped=true&"
import script from "./Step8.vue?vue&type=script&lang=ts&"
export * from "./Step8.vue?vue&type=script&lang=ts&"
import style0 from "./Step8.vue?vue&type=style&index=0&id=2c44da18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c44da18",
  null
  
)

export default component.exports